import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import PositionedSnackbar from './PositionedSnackbar';
import ClientProvider from './client';
export default createDemo(import.meta.url, PositionedSnackbar, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/snackbars/demos/positioned/PositionedSnackbar.tsx",
    "fileName": "PositionedSnackbar.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Grid from '@mui/material/Grid';\nimport Box from '@mui/material/Box';\nimport Button from '@mui/material/Button';\nimport Snackbar from '@mui/material/Snackbar';\nimport type { SnackbarOrigin } from '@mui/material/Snackbar';\n\ninterface State extends SnackbarOrigin {\n  open: boolean;\n}\n\nexport default function PositionedSnackbar() {\n  const [state, setState] = React.useState<State>({\n    open: false,\n    vertical: 'top',\n    horizontal: 'center',\n  });\n  const { vertical, horizontal, open } = state;\n\n  const handleClick = (newState: SnackbarOrigin) => () => {\n    setState({ ...newState, open: true });\n  };\n\n  const handleClose = () => {\n    setState({ ...state, open: false });\n  };\n\n  const buttons = (\n    <React.Fragment>\n      <Box sx={{ display: 'flex', justifyContent: 'center' }}>\n        <Button onClick={handleClick({ vertical: 'top', horizontal: 'center' })}>\n          Top-Center\n        </Button>\n      </Box>\n      <Grid container sx={{ justifyContent: 'center' }}>\n        <Grid size={6}>\n          <Button onClick={handleClick({ vertical: 'top', horizontal: 'left' })}>\n            Top-Left\n          </Button>\n        </Grid>\n        <Grid sx={{ textAlign: 'right' }} size={6}>\n          <Button onClick={handleClick({ vertical: 'top', horizontal: 'right' })}>\n            Top-Right\n          </Button>\n        </Grid>\n        <Grid size={6}>\n          <Button onClick={handleClick({ vertical: 'bottom', horizontal: 'left' })}>\n            Bottom-Left\n          </Button>\n        </Grid>\n        <Grid sx={{ textAlign: 'right' }} size={6}>\n          <Button onClick={handleClick({ vertical: 'bottom', horizontal: 'right' })}>\n            Bottom-Right\n          </Button>\n        </Grid>\n      </Grid>\n      <Box sx={{ display: 'flex', justifyContent: 'center' }}>\n        <Button onClick={handleClick({ vertical: 'bottom', horizontal: 'center' })}>\n          Bottom-Center\n        </Button>\n      </Box>\n    </React.Fragment>\n  );\n\n  return (\n    <Box sx={{ width: 500 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      {buttons}\n      <Snackbar\n        anchorOrigin={{ vertical, horizontal }}\n        open={open}\n        onClose={handleClose}\n        message=\"I love snacks\"\n        key={vertical + horizontal}\n      />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 77,
        "focusedLines": 8,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Grid from '@mui/material/Grid';\nimport Box from '@mui/material/Box';\nimport Button from '@mui/material/Button';\nimport Snackbar from '@mui/material/Snackbar';\nimport type { SnackbarOrigin } from '@mui/material/Snackbar';\n\ninterface State extends SnackbarOrigin {\n  open: boolean;\n}\n\nexport default function PositionedSnackbar() {\n  const [state, setState] = React.useState<State>({\n    open: false,\n    vertical: 'top',\n    horizontal: 'center',\n  });\n  const { vertical, horizontal, open } = state;\n\n  const handleClick = (newState: SnackbarOrigin) => () => {\n    setState({ ...newState, open: true });\n  };\n\n  const handleClose = () => {\n    setState({ ...state, open: false });\n  };\n\n  const buttons = (\n    <React.Fragment>\n      <Box sx={{ display: 'flex', justifyContent: 'center' }}>\n        <Button onClick={handleClick({ vertical: 'top', horizontal: 'center' })}>\n          Top-Center\n        </Button>\n      </Box>\n      <Grid container sx={{ justifyContent: 'center' }}>\n        <Grid size={6}>\n          <Button onClick={handleClick({ vertical: 'top', horizontal: 'left' })}>\n            Top-Left\n          </Button>\n        </Grid>\n        <Grid sx={{ textAlign: 'right' }} size={6}>\n          <Button onClick={handleClick({ vertical: 'top', horizontal: 'right' })}>\n            Top-Right\n          </Button>\n        </Grid>\n        <Grid size={6}>\n          <Button onClick={handleClick({ vertical: 'bottom', horizontal: 'left' })}>\n            Bottom-Left\n          </Button>\n        </Grid>\n        <Grid sx={{ textAlign: 'right' }} size={6}>\n          <Button onClick={handleClick({ vertical: 'bottom', horizontal: 'right' })}>\n            Bottom-Right\n          </Button>\n        </Grid>\n      </Grid>\n      <Box sx={{ display: 'flex', justifyContent: 'center' }}>\n        <Button onClick={handleClick({ vertical: 'bottom', horizontal: 'center' })}>\n          Bottom-Center\n        </Button>\n      </Box>\n    </React.Fragment>\n  );\n\n  return (\n    <Box sx={{ width: 500 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      {buttons}\n      <Snackbar\n        anchorOrigin={{ vertical, horizontal }}\n        open={open}\n        onClose={handleClose}\n        message=\"I love snacks\"\n        key={vertical + horizontal}\n      />\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 67
            },
            [
              "      ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi",
                "buttons"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 68
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Snackbar"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 69
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "anchorOrigin"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "pl-smi di-jv",
                "vertical"
              ],
              ", ",
              [
                "span",
                "pl-smi di-jv",
                "horizontal"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 70
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "open"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "open"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 71
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "onClose"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "handleClose"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 72
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "message"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "I love snacks",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 73
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "key"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "vertical"
              ],
              " ",
              [
                "span",
                "pl-k di-pu",
                "+"
              ],
              " ",
              [
                "span",
                "pl-smi di-jv",
                "horizontal"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 74
            },
            "      />"
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 77,
    "focusedLines": 8,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Grid",
      "@mui/material/Box",
      "@mui/material/Button",
      "@mui/material/Snackbar"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
